/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindingEvidence
 */
export interface FindingEvidence {
    /**
     * 
     * @type {number}
     * @memberof FindingEvidence
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof FindingEvidence
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FindingEvidence
     */
    file?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FindingEvidence
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof FindingEvidence
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the FindingEvidence interface.
 */
export function instanceOfFindingEvidence(value: object): value is FindingEvidence {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function FindingEvidenceFromJSON(json: any): FindingEvidence {
    return FindingEvidenceFromJSONTyped(json, false);
}

export function FindingEvidenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindingEvidence {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'description': json['description'],
        'file': json['file'] == null ? undefined : json['file'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function FindingEvidenceToJSON(json: any): FindingEvidence {
      return FindingEvidenceToJSONTyped(json, false);
  }

  export function FindingEvidenceToJSONTyped(value?: Omit<FindingEvidence, 'id'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'file': value['file'],
    };
}

